import { useState } from "react";
import { useEffect } from "react";

export const useClipboard = () => {

  const getTextFromClipboard = () => new Promise((resolve, reject)=>{
    getSupportClipboardRead()
      .then(()=>{
        navigator.clipboard.readText()
          .then(text => {
            resolve(text);
          })
          .catch(err => {
            reject("no se pudo leer el clipboard");
          });        
      })
      .catch(()=>{
        const text = window.prompt("El explorador no soporta el clipboard, porque estás en un sitio no seguro. Pegá aca el código del flujo que copiaste.", "");
        if(text){
          resolve(text);
        }else{
          reject();
        }
      })
  })

  const copyTextToClipboard = (text) => {
    getSupportClipboardWrite()
      .then(()=>{
        navigator.clipboard.writeText(text)
        .catch((err) => {
          console.error('No se pudo escribir contenido en el clipboard: ', err);
          fallbackCopyTextToClipboard(text);
        }); 
      })
      .catch(()=>{
        fallbackCopyTextToClipboard(text);
      })
  }

  const fallbackCopyTextToClipboard = (text) => {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      //console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }
    document.body.removeChild(textArea);
  }

  const getSupportClipboardWrite = () => new Promise((resolve, reject) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.permissions.query({ name: 'clipboard-write' })
        .then(permissionStatus => {
          if (permissionStatus.state === 'granted') {
            resolve();
          } else if (permissionStatus.state === 'prompt') {
            navigator.clipboard.writeText().then(()=>{
              resolve();
            }).catch(()=>{
              reject();
            })
          } else {
            reject();
          }
        })
        .catch(error => {
          reject();
        });
    } else {
      reject();
    }
  })
  
  const getSupportClipboardRead = () => new Promise((resolve, reject) => {
    if (navigator?.clipboard?.readText) {
      navigator.permissions.query({ name: 'clipboard-read' })
        .then(permissionStatus => {
          if (permissionStatus.state === 'granted') {
            resolve();
          } else if (permissionStatus.state === 'prompt') {
            navigator.clipboard.readText()
            .then(()=>{
              resolve();
            }).catch(()=>{
              reject();
            })
          } else {
            reject();
          }
        })
        .catch(error => {
          reject();
        });
    } else {
      reject();
    }
  })
  
  return { getTextFromClipboard, copyTextToClipboard };
}


